import { Component } from '@angular/core';

@Component( {
    selector: 'app-education',
    templateUrl: './education.component.html',
    styleUrls: [ './education.component.css' ],
    standalone: false
} )
export class EducationComponent { }
